import { render, staticRenderFns } from "./TreeViewItem.vue?vue&type=template&id=a315946e"
import script from "./TreeViewItem.ts?vue&type=script&lang=ts&external"
export * from "./TreeViewItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports